import React, { useEffect, useState } from 'react'
import { Link, useLoaderData, useParams } from 'react-router-dom'
import { updateProfile, setup } from '../../adapters/profle';
import SuccessStatus, { ErrorStatus } from '../../components/FormStatus';
import SelectInputField, { InputField, SelectOptionField } from '../../components/Input';
import { updateProfileRequest, updateSettingsRequest } from '../../requests/profile';
import useStore from '../../store/index';
import religions from '../../utils/religions.json';

export default function Settings() {
    const { type } = useParams();
    const [errors, setErrors ] = useState([]);

    const profileData = useLoaderData();
    const [ profileForm, setProfileForm ] = useState({...profileData.profile})
    const [ settingForm, setSettingForm ] = useState({...profileData.setting, notifyType: 'both', language: ''})
    const countries = useStore((state) => state.countries);
    const languages = useStore((state) => state.languages);
    const [ filteredLanguages, setFilteredLanguages ] = useState([]);


    const [filteredCountries, setFilteredCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [formStatus, setformStatus] = useState({
        status: false,
        message: ''
    })

    const handleInputChamge = (val, name) => {
        setErrors([]);
        profileForm[name] = val;
        setProfileForm(profileForm)
    }
    
    const handleSettingChange = (val, name) => {
        setErrors([]);
        settingForm[name] = val;
        setSettingForm(settingForm)
    }

    const updateMyProfile = async () => {
        try {
            delete profileForm.user;
            delete profileForm._id;
            delete profileForm.__v;
            const data = { ...profileForm }
            await updateProfileRequest.validate(data).then(() => {
                delete data.age;
                updateProfile({
                    firstname: data.firstname,
                    lastname: data.lastname,
                    othername: data.othername,
                    country: data.country,
                    state: data.state,
                    dateOfBirth: data.dateOfBirth,
                    phone: data.phone,
                    education: data.education,
                    occupation: data.occupation,
                    religion: data.religion,
                    empoymentStatus: data.empoymentStatus,
                    averageIncome: data.averageIncome,
                }).then((res) => {
                    if(res.status === 200) {
                        setformStatus({
                            status: true,
                            message:'Profile updated succesfully'
                        })
                    }
                })
            }).catch((e) => {
                setErrors(e.errors);
            })
            
        } catch (err) {
            setErrors(['Failed to update profile']);
        }
    }

    const updateSetting = () => {
        updateSettingsRequest.validate({
            notifyType: settingForm.notifyType,
            language: settingForm.language
        }).then(() => {
           try {
               const notifyType = settingForm.notifyType === 'email' ? 1 : (settingForm.notifyType === 'push notification' ? 2 : 3);
                setup({
                    notifyType,
                    language: settingForm.language
                }).then((res) => {
                    if (res.status === 200) {
                        setformStatus({
                            status: true,
                            message: 'Settings updated succesfully'
                        })
                    }
                })
           } catch (err) {
               setErrors(['Failed to update profile']);
           }

        }).catch((e) => {
            setErrors(e.errors);
        })
    }

    useEffect(() => {   
        const countryState = Object.values(countries);
        let countryNames = [];
        for (const country of countryState) {
            if (country.name) {
                countryNames.push(country.name)
            }
        }
        setFilteredCountries(countryNames)

        const langs = Object.values(languages)
        let languageNames = [];
        for (const lang of langs) {
            if (lang.name) {
                languageNames.push(lang.name)
            }
        }
        setFilteredLanguages(languageNames);
    }, [])
    
    return (
        <div className="relative">
            <div className="wrapper-2 animate__animated animate__fadeIn">
                <div className="gradient-bg relative rounded-b-lg py-12 mb-6 px-8 flex lg:items-center lg:flex-row flex-col justify-start lg:justify-between items-start gap-4">
                    <div>
                        <h1 className="font-fira xl:text-2xl text-xl">Profile Settings</h1>
                        <div className="flex mt-1 gap-2 font-semibold text-xs text-gray-800">
                            <Link to="/account/dashboard" className="text-blue-900" >Dashboard</Link>
                            <span>/</span>
                            <Link to="/account/profile" className="text-blue-900" >Profile</Link>
                            <span>/</span>
                            <span  >Settings</span>
                        </div>
                    </div>
                </div>
                <div className="px-6">

                    <h4 className="mb-6 capitalize font-fira text-lg font-semibold">
                        Update {type} Info
                    </h4>

                    <div className="mt-6">
                        <ErrorStatus errors={errors} />
                        <SuccessStatus showStatus={formStatus.status} message={formStatus.message} />
                    </div>
                </div>
                <div className="bg-gray-100 py-6 px-6 lg:px-8 rounded-t-2xl rounded-lg border-2 border-gray-300">
                    {type !== 'setting' && <form onSubmit={(e) => {
                        e.preventDefault();
                        setErrors([]);
                        updateMyProfile();
                    }}>
                        {type === 'personal' && <div>
                            <InputField
                                onChange={(e) => {
        
                                    handleInputChamge(e.target.value, 'firstname')
                                }}
                                isRequired={true} type="text" placeholder="Firstname" name="firstname" defaultValue={profileForm.firstname} label="First name" />

                            <InputField
                                onChange={(e) => {
        
                                    handleInputChamge(e.target.value, 'lastname')
                                }}
                                isRequired={true} type="text" placeholder="Last name" name="lastname" defaultValue={profileForm.lastname} label="Last name" />

                            <InputField
                                onChange={(e) => {
        
                                    handleInputChamge(e.target.value, 'othername')
                                }}
                                isRequired={true} type="text" placeholder="Other name" name="othername" defaultValue={profileForm.othername} label="Other name" />

                            <SelectInputField isRequired={true} placeholder="Country" onChange={(e) => {

                                handleInputChamge(e.target.value, 'country')
                            }} name="country" defaultValue={profileForm.country} id="country" label="Country" options={filteredCountries} />


                            <SelectInputField isRequired={true} placeholder="State" onChange={(e) => {

                                handleInputChamge(e.target.value, 'state')
                            }} name="state" id="state" defaultValue={profileForm.state} label="State" options={states.length > 0 ? states : []} />

                            <SelectInputField isRequired={true} placeholder="Religion" onChange={(e) => {

                                handleInputChamge(e.target.value, 'religion')
                            }} name="religion" defaultValue={profileForm.religion} id="religion" label="Religion" options={religions} />
                        </div>}

                        {type === 'employment' && <div>
                            <SelectInputField isRequired={true} placeholder="Education Status" onChange={(e) => {
                                setErrors([]);
                                handleInputChamge(e.target.value, 'education')
                            }} name="education" defaultValue={profileForm.education} id="education" label="Education" options={["O'Level", "Bachelor's Degree", "PHD"]} />

                            <InputField isRequired={false} type="text" placeholder="Occupation" onChange={(e) => {
                                setErrors([]);
                                handleInputChamge(e.target.value, 'occupation')
                            }} defaultValue={profileForm.occupation} name="occupation" id="occupation" label="Occupation" />

                            <SelectInputField isRequired={true} placeholder="Employment Status" onChange={(e) => {
                                setErrors([]);
                                handleInputChamge(e.target.value, 'empoymentStatus')
                            }} name="empoymentStatus" defaultValue={profileForm.empoymentStatus} id="empoymentStatus" label="Empoyment Status" options={["Employed", "UnEmployed", "SelfEmployed"]} />

                            <InputField isRequired={true} type="text" placeholder="0.00" onChange={(e) => {
                                setErrors([]);
                                handleInputChamge(e.target.value, 'averageIncome')
                            }} defaultValue={profileForm.averageIncome} name="averageIncome" id="averageIncome" label="Average Income" /> 
                        </div>}


                        <div className="mt-4">
                            <button type="submit" className="text-white bg-blue-800 hover:bg-blue-900 py-3 w-full md:w-1/5 text-center rounded-lg text-xs font-semibold">Save Changes</button>
                        </div>
                    </form>}



                    {type === 'setting' && <form onSubmit={(e) => {
                        e.preventDefault();
                        setErrors([]);
                        updateSetting();
                    }}>
                        <SelectOptionField isRequired={true} placeholder="Notification Setting" onChange={(e) => {
                            setErrors([]);
                            handleSettingChange(e.target.value, 'notifyType')
                        }} name="notification" defaultValue={settingForm.notifyType} id="notifyType" label="Notification Type" options={["email", "push notification", "both"]} />

                        <SelectInputField isRequired={true} placeholder="Language Setting" onChange={(e) => {
                            setErrors([]);
                            handleSettingChange(e.target.value, 'language')
                        }} name="language" defaultValue={settingForm.language} id="language" label="Prefered Language" options={filteredLanguages} />

                        <div className="mt-4">
                            <button type="submit" className="text-white bg-blue-800 hover:bg-blue-900 py-3 w-full md:w-1/5 text-center rounded-lg text-xs font-semibold">Save Changes</button>
                        </div>
                    </form>}
                </div>
            </div>
        </div>
    )
}
